import userEvaluationApi from 'Api/axios/user-evaluation-api';
import useFetchData from 'Hooks/useFetchData';
import React, { useEffect } from 'react';

interface Props {
  courseId: string;
  userId: string;
}

const useEvaluationsTab = ({ courseId, userId }: Props) => {
  // TODO: Obtener las evaluaciones que pertenecen a este curso en específico
  const {
    allData: userEvaluations,
    loading: userEvaluationsLoading,
    fetchAll: fetchUserEvaluations,
  } = useFetchData({
    getAll: () => userEvaluationApi.getUserEvaluationsByCourseId(courseId, userId),
  });

  // Obtenemos las evaluaciones de los empleados que pertenecen a este curso
  // refrescamos la data cuando el curso cambie
  useEffect(() => {
    fetchUserEvaluations();
  }, [courseId]);

  return {
    userEvaluations,
    userEvaluationsLoading,
  };
};

export default useEvaluationsTab;
